import {Component, forwardRef, input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MessageTranslateService} from "@shared/services";

enum SharedSearchOption {
  SHARED = 'Shared',
  PRIVATE = 'Private',
}

@Component({
  selector: 'app-ace-select-shared',
  templateUrl: './ace-select-shared.component.html',
  styleUrls: ['./ace-select-shared.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AceSelectSharedComponent), multi: true }],
  standalone: false
})

export class AceSelectSharedComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe: Subject<void> = new Subject();
  readonly selectControl = new FormControl<SharedSearchOption | null>(null);
  readonly SharedSearchOption = SharedSearchOption;

  placeholder = input<string>(this.messageTranslateService.instant('Either'));

  constructor(private messageTranslateService: MessageTranslateService) { }

  ngOnInit(): void {
    this.selectControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((shared: SharedSearchOption) => {
      this.onChange(AceSelectSharedComponent.sharedOptionToBoolean(shared));
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private onTouched: any = () => {};

  private onChange: any = (_) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.selectControl.setValue(AceSelectSharedComponent.booleanToSharedOption(value));
  }

  private static booleanToSharedOption(value: boolean): SharedSearchOption | null {
    if (value != null) {
      return value ? SharedSearchOption.SHARED : SharedSearchOption.PRIVATE;
    } else {
      return null;
    }
  }

  private static sharedOptionToBoolean(shared: SharedSearchOption): boolean {
    if (shared === SharedSearchOption.SHARED) {
      return true;
    } else if (shared === SharedSearchOption.PRIVATE) {
      return false;
    } else {
      return null;
    }
  }

}
